// extracted by mini-css-extract-plugin
module.exports = {"groupEditor":"AdminCategoryEdit_groupEditor__nxMJo","fullcol":"AdminCategoryEdit_fullcol__1Imlo"};